import './Results.css';
import { tests } from '../Test/questions';
import { useNavigate } from 'react-router-dom';

export default function Results() {
    const navigate = useNavigate();

    const results = tests.map(test => ({
        ...test,
        result: JSON.parse(localStorage.getItem(test.key)),
    }));

    return (
        <section className="results">
            <header className="results__header">
                <span>Результаты теста</span>
                <span>{tests.length} сфер</span>
            </header>

            <div className="results__intro">
                <h1 className="results__title">
                    Ваш<br />
                    <em>результат</em>
                </h1>

                <p className="results__description">
                    Здесь собраны результаты по каждому типу отдыха.
                    Посмотрите, где ваш организм и психика получают
                    достаточно восстановления, а где им стоит помочь.
                </p>
            </div>

            <div className="results__list">
                {results.map((test, i) => (
                    <article className="results__item" key={test.key}>
                        <div className="results__number">
                            {test.number || String(i + 1).padStart(2, '0')}
                        </div>

                        <div className="results__content">
                            <div className="results__type">
                                {test.title} {test.subtitle}
                            </div>

                            {test.result ? (
                                <>
                                    <h2>{test.result.title}</h2>
                                    <p>{test.result.text}</p>

                                    {test.resultDescription && (
                                        <div className="results__extra">
                                            {test.resultDescription}
                                        </div>
                                    )}
                                </>
                            ) : (
                                <p className="results__empty">
                                    Результат ещё не сохранён.
                                </p>
                            )}
                        </div>
                    </article>
                ))}
            </div>

            <section className="results__care">
                <div className="results__care-number">∞</div>

                <div className="results__care-content">
                    <span className="results__care-label">
                        Важно помнить
                    </span>

                    <h2>
                        Забота о себе —<br />
                        <em>это не эгоизм.</em>
                    </h2>

                    <p>
                        Это необходимость. Только отдохнувший человек
                        может полноценно заботиться о других и
                        реализовывать свои цели.
                    </p>

                    <button
                        className="results__button"
                        onClick={() => navigate('/')}
                    >
                        <span>Вернуться на главную</span>
                        <span>→</span>
                    </button>
                </div>
            </section>
        </section>
    );
}